import Closet from 'assets/icon/closet.svg'
import Dress from 'assets/icon/dress.svg'
import Hang from 'assets/icon/hang.svg'
import { Img } from 'component/Image'
import { observer } from 'mobx-react-lite'
import { opt } from 'store/opt'
import css from './MainColor.module.scss'

type Props = {
  size: number
}

function getSvg() {
  const { type } = opt.options.icon ?? {}
  if (type === 'dress') return Dress
  if (type === 'closet') return Closet
  return Hang
}

export const MainIcon = observer(({ size }: Props) => {
  const { url } = opt.options.icon ?? {}
  const style = { width: size, height: size }
  const IconSvg = getSvg()

  if (url) return <Img src={url} style={style} />
  return <IconSvg width={size} height={size} className={css.color} />
})
